<template>
  <v-card light flat tile :color="!message.operator ? 'rgba(248, 196, 5, 0.2)' : ''" class="py-0">
    <v-card-title class="subtitle-1 py-1">
      <span v-if="message.operator" class="secondary--text">{{ message.operator.email }}</span>
      <a :href="`/#/persons/${personid}`" v-else>{{title}}</a>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span class="grey--text text--darken-2">{{time}}</span>
    </v-card-title>
    <v-card-text class="py-1">
      <p>{{ message.content }}</p>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ChatMessage',
  props: [
    'message', 'title', 'personid'
  ],
  computed: {
    oper () {
      return this.message.operatorid !== null
    },
    time () {
      return moment(this.message.cts).fromNow()
    }
  }
}
</script>

<style>
</style>
